import axios from 'axios';
// import BaseUrl from '../Util/BaseUrl';

// const API_URL = BaseUrl.baseUrl+"api/blog";

const API_URL = 'https://api.blogfortis.com/api/blog/'
const web = '541c7d80-4ea8-4aa1-a1e7-2a6cbc797e0a';

const getAllBlogs = async (page = 0, size = 10) => {
    try {
        const response = await axios.get(API_URL+'web', {
            params: { page, size , web}
        });
        return response.data;
    } catch (error) {
        throw new Error(error.response ? error.response.data : 'Failed to fetch blogs');
    }
};

// const getBlogById = async (blog) => {
//     try {
//         const response = await axios.get(API_URL+'detail', {
//             params: { web, blog}
//         });
//         return response.data;
//     } catch (error) {
//         throw new Error(error.response ? error.response.data : 'Failed to fetch blog');
//     }
// };

const getBlogByTitle = async (title) => {
    try {
        const response = await axios.get(API_URL+'by-title', {
            params: { web, title}
        });
        return response.data;
    } catch (error) {
        throw new Error(error.response ? error.response.data : 'Failed to fetch blog');
    }
};

// const getRandomBlogs = async (size = 6) => {
//     try {
//         const response = await axios.get(`${API_URL}/random/${size}`);
//         return response.data;
//     } catch (error) {
//         throw new Error(error.response ? error.response.data : 'Failed to fetch blogs');
//     }
// };


const BlogService = {
    getAllBlogs,
    // getBlogById,
    getBlogByTitle
    // getRandomBlogs
};

export default BlogService;